export const appLog = (message: any) => {
  window.ReactNativeWebView?.postMessage(
    JSON.stringify({ type: "debug", message })
  );
};
